import { apiClient } from './api';

const STAFF_ENDPOINT = '/staff';

export const staffTrackingService = {
  // Listar funcionários
  async getStaff(params = {}) {
    const queryParams = new URLSearchParams();
    
    if (params.role) queryParams.append('role', params.role);
    if (params.department) queryParams.append('department', params.department);
    if (params.status) queryParams.append('status', params.status);
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    
    const url = `${STAFF_ENDPOINT}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const response = await apiClient.get(url);
    return response.data;
  },

  // Obter funcionário específico
  async getStaffById(staffId) {
    const response = await apiClient.get(`${STAFF_ENDPOINT}/${staffId}`);
    return response.data;
  },

  // Criar funcionário
  async createStaff(staffData) {
    const response = await apiClient.post(STAFF_ENDPOINT, staffData);
    return response.data;
  },

  // Atualizar funcionário
  async updateStaff(staffId, staffData) {
    const response = await apiClient.put(`${STAFF_ENDPOINT}/${staffId}`, staffData);
    return response.data;
  },

  // Desativar funcionário
  async deleteStaff(staffId) {
    const response = await apiClient.delete(`${STAFF_ENDPOINT}/${staffId}`);
    return response.data;
  },

  // Associar beacon ao funcionário
  async associateBeacon(staffId, beaconData) {
    const response = await apiClient.put(`${STAFF_ENDPOINT}/${staffId}/beacon`, beaconData);
    return response.data;
  },

  // Obter localização atual do funcionário
  async getStaffLocation(staffId) {
    const response = await apiClient.get(`${STAFF_ENDPOINT}/${staffId}/location`);
    return response.data;
  },

  // Atualizar localização do funcionário
  async updateStaffLocation(staffId, locationData) {
    const response = await apiClient.post(`${STAFF_ENDPOINT}/${staffId}/location`, locationData);
    return response.data;
  },

  // Obter histórico de localização
  async getStaffHistory(staffId, params = {}) {
    const queryParams = new URLSearchParams();
    
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    if (params.limit) queryParams.append('limit', params.limit);
    
    const url = `${STAFF_ENDPOINT}/${staffId}/history${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const response = await apiClient.get(url);
    return response.data;
  },

  // Disparar alerta de pânico
  async triggerPanicAlert(staffId, alertData) {
    const response = await apiClient.post(`${STAFF_ENDPOINT}/${staffId}/panic`, alertData);
    return response.data;
  },

  // Obter turnos do funcionário
  async getStaffShifts(staffId, params = {}) {
    const queryParams = new URLSearchParams();
    
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    
    const url = `${STAFF_ENDPOINT}/${staffId}/shifts${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const response = await apiClient.get(url);
    return response.data;
  },

  // Criar turno
  async createStaffShift(staffId, shiftData) {
    const response = await apiClient.post(`${STAFF_ENDPOINT}/${staffId}/shifts`, shiftData);
    return response.data;
  },

  // Obter alertas do funcionário
  async getStaffAlerts(staffId, params = {}) {
    const queryParams = new URLSearchParams();
    
    if (params.status) queryParams.append('status', params.status);
    if (params.severity) queryParams.append('severity', params.severity);
    if (params.limit) queryParams.append('limit', params.limit);
    
    const url = `${STAFF_ENDPOINT}/${staffId}/alerts${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const response = await apiClient.get(url);
    return response.data;
  },

  // Atualizar zonas permitidas/restritas
  async updateStaffZones(staffId, zoneData) {
    const response = await apiClient.put(`${STAFF_ENDPOINT}/${staffId}/zones`, zoneData);
    return response.data;
  },

  // Utilitários para filtros
  getRoles() {
    return [
      { value: 'doctor', label: 'Médico' },
      { value: 'nurse', label: 'Enfermeiro' },
      { value: 'technician', label: 'Técnico' },
      { value: 'admin', label: 'Administrativo' },
      { value: 'security', label: 'Segurança' },
      { value: 'cleaning', label: 'Limpeza' },
      { value: 'maintenance', label: 'Manutenção' }
    ];
  },

  getAccessLevels() {
    return [
      { value: 'basic', label: 'Básico' },
      { value: 'elevated', label: 'Elevado' },
      { value: 'admin', label: 'Administrador' },
      { value: 'emergency', label: 'Emergência' }
    ];
  },

  getShifts() {
    return [
      { value: 'morning', label: 'Manhã' },
      { value: 'afternoon', label: 'Tarde' },
      { value: 'night', label: 'Noite' },
      { value: 'flexible', label: 'Flexível' }
    ];
  },

  getEmploymentStatuses() {
    return [
      { value: 'active', label: 'Ativo' },
      { value: 'inactive', label: 'Inativo' },
      { value: 'vacation', label: 'Férias' },
      { value: 'leave', label: 'Licença' }
    ];
  }
};